function handleRequirementsModalTriggers() {
    document.addEventListener('click', function(event) {
        const trigger = event.target.closest('a[href^="#modal-"]');
        if (!trigger || !window.bootstrap) return;

        const modalId = trigger.getAttribute('href').replace('#', '');
        const modalElement = document.getElementById(modalId);
        if (!modalElement || !modalElement.hasAttribute('data-requirements-modal')) return;

        event.preventDefault();
        bootstrap.Modal.getOrCreateInstance(modalElement).show();
    });
}

function handleRequirementsModalCtas() {
    document.addEventListener('click', function(event) {
        const cta = event.target.closest('a[data-requirements-modal-cta]');
        if (!cta || !window.bootstrap) return;

        const modalElement = cta.closest('[data-requirements-modal]');
        if (!modalElement) return;

        const modal = bootstrap.Modal.getOrCreateInstance(modalElement);

        if (cta.getAttribute('target') === '_blank') {
            modal.hide();
            return;
        }

        event.preventDefault();

        const href = cta.getAttribute('href');
        const navigate = function() {
            window.location.href = href;
        };

        if (modalElement.classList.contains('show')) {
            modalElement.addEventListener('hidden.bs.modal', navigate, { once: true });
            modal.hide();
        } else {
            navigate();
        }
    });
}

function getRequirementsModalSessionKey(modalElement) {
    return 'requirementsModalAutoOpened:' + modalElement.id;
}

function hasRequirementsModalAutoOpened(modalElement) {
    try {
        return window.sessionStorage.getItem(getRequirementsModalSessionKey(modalElement)) === 'true';
    } catch (error) {
        return modalElement.dataset.requirementsModalAutoOpened === 'true';
    }
}

function setRequirementsModalAutoOpened(modalElement) {
    try {
        window.sessionStorage.setItem(getRequirementsModalSessionKey(modalElement), 'true');
    } catch (error) {
        modalElement.dataset.requirementsModalAutoOpened = 'true';
    }
}

function handleRequirementsModalAutoOpen() {
    if (!window.bootstrap) return;

    document.querySelectorAll('[data-requirements-modal][data-requirements-modal-auto-open="true"]').forEach(function(modalElement) {
        modalElement.addEventListener('shown.bs.modal', function() {
            setRequirementsModalAutoOpened(modalElement);
        });

        if (hasRequirementsModalAutoOpened(modalElement)) return;

        const delay = parseFloat(modalElement.dataset.requirementsModalDelay || '0');
        if (Number.isNaN(delay) || delay < 0) return;

        window.setTimeout(function() {
            if (hasRequirementsModalAutoOpened(modalElement)) return;

            setRequirementsModalAutoOpened(modalElement);
            bootstrap.Modal.getOrCreateInstance(modalElement).show();
        }, delay * 1000);
    });
}

handleRequirementsModalTriggers();
handleRequirementsModalCtas();
handleRequirementsModalAutoOpen();
